import { PureComponent } from "react";
import { LoadingIndicator } from "../../../orgs/orgs-styles";
import { onAuthStateChanged } from "../../../../../lib/firebase-auth";
import { getAppFacilities } from "webapp/lib/app-renderer";
import { IntegrateWithStripeBody } from "common/firebase-function-types";
import { logError } from "common/debug-print";

export class ConnectStripePreScreen extends PureComponent {
    private doingStripeRedirect = false;

    public componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);

        onAuthStateChanged(async user => {
            if (this.doingStripeRedirect) return;
            if (user === undefined) return;

            this.doingStripeRedirect = true;
            const postConnectURL = new URL(window.location.href);
            postConnectURL.pathname = "/";

            const body: IntegrateWithStripeBody = {
                postConnectURL: postConnectURL.href,
                forTemplateStore: searchParams.get("forTemplateStore") !== null,
                onBehalfOf: searchParams.get("onBehalfOf") ?? undefined,
                closeOnSuccess: true,
            };

            // We assume that the user being defined means we are successfully auth'd.
            const integrationResponse = await getAppFacilities().callAuthCloudFunction("integrateWithStripe", body);

            if (integrationResponse === undefined || !integrationResponse.ok) {
                logError(`Could not get Stripe OAuth URL: ${integrationResponse?.statusText}`);
                window.close();
                return;
            }
            const { redirectURL } = await integrationResponse.json();
            if (redirectURL === undefined) {
                logError("Stripe OAuth redirect was undefined?");
                window.close();
                return;
            }
            window.location.assign(redirectURL);
        });
    }

    public render() {
        return <LoadingIndicator />;
    }
}
